import { render, staticRenderFns } from "./controlType.vue?vue&type=template&id=5dc973c0&scoped=true"
import script from "./controlType.vue?vue&type=script&lang=js"
export * from "./controlType.vue?vue&type=script&lang=js"
import style0 from "./controlType.vue?vue&type=style&index=0&id=5dc973c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc973c0",
  null
  
)

export default component.exports